import { Modal, Title } from '@wyz/ui';
import { PropsWithChildren, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { Trans } from '~/common/context';
import { IUserCustomer } from '~/common/types';
import { WcwSearchBar } from '~/purchase/components';
import { IWcwSearchFormSchema } from '~/purchase/schemas';

type Props = {
  open: boolean;
  onClose: () => void;
  customer: IUserCustomer;
};

function WcwSearchModal({
  open,
  onClose,
  customer,
  children,
}: PropsWithChildren<Props>) {
  const methods = useFormContext<IWcwSearchFormSchema>();
  const initialValues = useRef(methods.getValues());

  return (
    <Modal.Container
      open={open}
      onClose={() => {
        methods.reset(initialValues.current);
        onClose();
      }}
      size='xl'
    >
      <Modal.Header>
        <Modal.Title>
          <Title heading='xl' weight='bold'>
            <Trans i18nKey='app.common.button.new_search' />
          </Title>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <WcwSearchBar customer={customer} />
      </Modal.Body>
      <Modal.Footer>
        <div className='w-100'>{children}</div>
      </Modal.Footer>
    </Modal.Container>
  );
}

export default WcwSearchModal;
